import { render, staticRenderFns } from "./updatesent.vue?vue&type=template&id=a810a07e&"
import script from "./updatesent.vue?vue&type=script&lang=js&"
export * from "./updatesent.vue?vue&type=script&lang=js&"
import style0 from "./updatesent.vue?vue&type=style&index=0&id=a810a07e&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports